"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var UserCircle = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "user-circle" },
            react_1.default.createElement("path", { id: "Icon", d: "M4.39578 19.0477C4.18 19.5561 4.4172 20.1431 4.92558 20.3589C5.43397 20.5747 6.02102 20.3375 6.23681 19.8291L4.39578 19.0477ZM17.7632 19.8291C17.979 20.3375 18.566 20.5747 19.0744 20.3589C19.5828 20.1431 19.82 19.5561 19.6042 19.0477L17.7632 19.8291ZM9 16C6.92959 16 5.15534 17.2582 4.39578 19.0477L6.23681 19.8291C6.6939 18.7522 7.76026 18 9 18V16ZM15 16H9V18H15V16ZM19.6042 19.0477C18.8447 17.2582 17.0704 16 15 16V18C16.2397 18 17.3061 18.7522 17.7632 19.8291L19.6042 19.0477ZM15 9.5C15 11.1569 13.6569 12.5 12 12.5V14.5C14.7614 14.5 17 12.2614 17 9.5H15ZM12 12.5C10.3431 12.5 9 11.1569 9 9.5H7C7 12.2614 9.23858 14.5 12 14.5V12.5ZM9 9.5C9 7.84315 10.3431 6.5 12 6.5V4.5C9.23858 4.5 7 6.73858 7 9.5H9ZM12 6.5C13.6569 6.5 15 7.84315 15 9.5H17C17 6.73858 14.7614 4.5 12 4.5V6.5ZM21 12C21 16.9706 16.9706 21 12 21V23C18.0751 23 23 18.0751 23 12H21ZM12 21C7.02944 21 3 16.9706 3 12H1C1 18.0751 5.92487 23 12 23V21ZM3 12C3 7.02944 7.02944 3 12 3V1C5.92487 1 1 5.92487 1 12H3ZM12 3C16.9706 3 21 7.02944 21 12H23C23 5.92487 18.0751 1 12 1V3Z" }))));
};
exports.default = UserCircle;
